//Order is pretty arbitrary, but was requested to put these as the default colour scheme.
export const OGL_COLOURS: Array<`#${string}`> = [
  '#DB504A',
  '#00B9AF',
  '#136F63',
  '#F18805',
  '#9A031E',
  '#006DAA',
  '#ECA400',
  '#534bae',
  '#DD7596',
  '#3E92CC',
  '#700353',
  '#D95D39',
  '#000051',
  '#ffffff',
  '#1a237e',
  '#2F1435',
];

//Just a bunch of material colours for a generated pie chart...
//Note - Repeated each colour scheme one with darker versions of the colours to help with charts with many entries.
export const COLOURS: Array<`#${string}`> = [
  '#F44336', //0
  '#2196F3', //1
  '#8BC34A', //2
  '#FF5722', //3
  '#E91E63', //4
  '#03A9F4', //5
  '#CDDC39', //6
  '#9C27B0', //7
  '#00BCD4', //8
  '#FFEB3B', //9
  '#673AB7', //10
  '#009688', //11
  '#FFC107', //12
  '#607D8B', //13
  '#3F51B5', //14
  '#4CAF50', //15
  '#FF9800', //16
  '#9E9E9E', //17
  '#795548', //18
  '#bb3329', //19
  '#1972b9', //20
  '#658e36', //21
  '#af3c17',
  '#a21545',
  '#027db5',
  '#9fa92c',
  '#731d82',
  '#0091a3',
  '#b6a82a',
  '#522e91',
  '#00776c',
  '#b58905',
  '#4f6772',
  '#334192',
  '#3a863d',
  '#c67600',
  '#747474',
  '#5b4036',
];

export const RAINBOW_COLOURS: Array<`#${string}`> = [
  '#f44336',
  '#E91E63',
  '#9C27B0',
  '#673AB7',
  '#3F51B5',
  '#2196F3',
  '#03A9F4',
  '#00BCD4',
  '#009688',
  '#4CAF50',
  '#8BC34A',
  '#CDDC39',
  '#FFEB3B',
  '#FFC107',
  '#FF9800',
  '#FF5722',
  '#a5392f',
  '#a41d58',
  '#742588',
  '#402c80',
  '#2d3a82',
  '#1663a1',
  '#026e9f',
  '#008c9e',
  '#007d71',
  '#377f3a',
  '#5d8231',
  '#909b28',
  '#a29525',
  '#ae8405',
  '#bd7100',
  '#af3c17',
];

export const BLIND_COLOURS: Array<`#${string}`> = [
  '#332288',
  '#6699cc',
  '#88ccee',
  '#44aa99',
  '#117733',
  '#999933',
  '#ddcc77',
  '#661100',
  '#cc6677',
  '#aa4466',
  '#882255',
  '#aa4499',
  '#332288',
  '#6699cc',
  '#88ccee',
  '#44aa99',
  '#117733',
  '#999933',
  '#ddcc77',
  '#661100',
  '#cc6677',
  '#aa4466',
  '#882255',
  '#aa4499',
  '#332288',
  '#6699cc',
  '#88ccee',
  '#44aa99',
  '#117733',
  '#999933',
  '#ddcc77',
  '#661100',
  '#cc6677',
  '#aa4466',
  '#882255',
  '#aa4499',
  '#332288',
  '#6699cc',
  '#88ccee',
  '#44aa99',
  '#117733',
  '#999933',
  '#ddcc77',
  '#661100',
  '#cc6677',
  '#aa4466',
  '#882255',
  '#aa4499',
  '#332288',
  '#6699cc',
  '#88ccee',
  '#44aa99',
  '#117733',
  '#999933',
  '#ddcc77',
  '#661100',
  '#cc6677',
  '#aa4466',
  '#882255',
  '#aa4499',
  '#332288',
  '#6699cc',
  '#88ccee',
  '#44aa99',
  '#117733',
  '#999933',
  '#ddcc77',
  '#661100',
  '#cc6677',
  '#aa4466',
  '#882255',
  '#aa4499',
  '#332288',
  '#6699cc',
  '#88ccee',
  '#44aa99',
  '#117733',
  '#999933',
  '#ddcc77',
  '#661100',
  '#cc6677',
  '#aa4466',
  '#882255',
  '#aa4499',
  '#332288',
  '#6699cc',
  '#88ccee',
  '#44aa99',
  '#117733',
  '#999933',
  '#ddcc77',
  '#661100',
  '#cc6677',
  '#aa4466',
  '#882255',
  '#aa4499',
];

export const TRICOLOUR_STANDARD: Array<`#${string}`> = ['#4caf50', '#ffa000', '#f44336'];
export const TRICOLOUR_BLIND: Array<`#${string}`> = ['#00dff5', '#e68f00', '#cd342a'];
